import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// Carrega todos os locales/<lng>/<ns>.json automaticamente (Vite glob).
// Idiomas e namespaces novos entram só criando o arquivo.
const modules = import.meta.glob('./locales/*/*.json', { eager: true })
const resources = {}
for (const [path, mod] of Object.entries(modules)) {
  const [, lng, ns] = path.match(/\.\/locales\/([^/]+)\/([^/]+)\.json$/) || []
  if (!lng) continue
  resources[lng] = resources[lng] || {}
  resources[lng][ns] = mod.default
}

export const LANGS = [
  { code: 'pt-BR', short: 'PT', label: 'Português (BR)' },
  { code: 'en', short: 'EN', label: 'English' },
  { code: 'fr', short: 'FR', label: 'Français' },
  { code: 'es', short: 'ES', label: 'Español' },
  { code: 'hy', short: 'HY', label: 'Հայերեն' },
]

const STORAGE_KEY = 'volis-lang'
const saved = typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null

// ?lang= vence o localStorage e é resolvido ANTES do primeiro render: é assim que a
// página de impressão do relatório recebe o idioma (o Chromium do Gotenberg não tem
// localStorage). Aceita 'pt' além de 'pt-BR'.
function langFromUrl() {
  try {
    const raw = new URLSearchParams(window.location.search).get('lang')
    if (!raw) return null
    if (resources[raw]) return raw
    const base = raw.split('-')[0].toLowerCase()
    return Object.keys(resources).find(code => code.split('-')[0].toLowerCase() === base) || null
  } catch { return null }
}

const initialLang = langFromUrl() || (saved && resources[saved] ? saved : 'pt-BR')

i18n.use(initReactI18next).init({
  resources,
  lng: initialLang,
  fallbackLng: 'pt-BR',
  ns: Object.keys(resources['pt-BR'] || { common: 1 }),
  defaultNS: 'common',
  interpolation: { escapeValue: false },
  returnEmptyString: false,
})

export function setLanguage(code) {
  localStorage.setItem(STORAGE_KEY, code)
  i18n.changeLanguage(code)
}

// Locale Intl correspondente ao idioma ativo (números, datas)
export function intlLocale() {
  return { 'pt-BR': 'pt-BR', en: 'en-US', fr: 'fr-FR', es: 'es-ES', hy: 'hy-AM' }[i18n.language] || 'pt-BR'
}

export default i18n
